import { render, staticRenderFns } from "./form-simulate-payment.vue?vue&type=template&id=5fbd5429&"
import script from "./form-simulate-payment.vue?vue&type=script&lang=js&"
export * from "./form-simulate-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports